import { render, staticRenderFns } from "./PastClassesTable.vue?vue&type=template&id=1cd45d20"
import script from "./PastClassesTable.vue?vue&type=script&lang=js"
export * from "./PastClassesTable.vue?vue&type=script&lang=js"
import style0 from "./PastClassesTable.vue?vue&type=style&index=0&id=1cd45d20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports